import Component from '@glimmer/component'
import type FeaturesService from 'teacher-ui-client/services/features'
import { service } from '@ember/service'
import SideNavItem from 'teacher-ui-client/components/side-nav/item'
import SideNavIconComponent from 'teacher-ui-client/components/side-nav/icon'
import { t } from 'ember-intl'

interface WhatsNewLinkSignature {
  Args: {
    featureFlag: string
  }
}

export class WhatsNewLink extends Component<WhatsNewLinkSignature> {
  @service features!: FeaturesService

  get isVisible() {
    return this.features.isEnabled(this.args.featureFlag)
  }

  <template>
    {{#if this.isVisible}}
      <SideNavItem @linkTo="subscription-type.blog">
        <SideNavIconComponent @phosphorIcon="phosphor-sparkle-fill" />
        <span> {{t "whatsNew"}}</span>
      </SideNavItem>
    {{/if}}
  </template>
}

export default WhatsNewLink
